
export function Base64UrlEncode(str: string): string {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function Base64UrlDecode(str: string): string {
  str = str
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  while (str.length % 4) {
    str += '=';
  }
  return atob(str);
}
